import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { LogoComponent } from '../logo/logo.component';
import { NgIf } from '@angular/common';
import { CURRENT_USER } from '../../../shared/tokens/current-user';
import { User } from '../../../shared/interfaces/user';
import { RouterLink } from '@angular/router';
import { CanPipe } from '../../../shared/pipes/can.pipe';
import { MatDialog } from '@angular/material/dialog';
import { PasswordPinDialogComponent } from '../../dialogs/password-pin-dialog/password-pin-dialog.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-top-bar',
    standalone: true,
    imports: [
        LogoComponent,
        NgIf,
        RouterLink,
        CanPipe,
    ],
    templateUrl: './top-bar.component.html',
    styleUrl: './top-bar.component.scss',
})
export class TopBarComponent {
    @Input() public alt: string = '';

    @Input() public logo: string | undefined;

    public constructor(
        @Inject(CURRENT_USER) protected readonly user: User,
        private readonly dialog: MatDialog,
    ) {
        //
    }

    public redirect(): void {
        this.dialog.open(PasswordPinDialogComponent, {
            data: { user: this.user },
            disableClose: true,
            width: '400px',
        });
    }
}
